/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { inject, Injectable } from '@angular/core'
import { LocalisationService } from '@myprofile-ui/myprofile-localisation-api'
import { TranslateService } from '@ngx-translate/core'
import { lastValueFrom, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { MyprofileBirthdayWidgetMode } from '../myprofile-birthday-widget-mode'

@Injectable({
  providedIn: 'root',
})
export class MyProfileBirthdayService {
  private _translateService = inject(TranslateService)
  private _localisationService = inject(LocalisationService)

  public async setInitialConfiguration(
    country: string,
    locale: string,
    mode: MyprofileBirthdayWidgetMode = MyprofileBirthdayWidgetMode.EXTERNAL,
  ): Promise<void> {
    const translations = await lastValueFrom(this._getTranslations(country, locale))

    if (mode !== MyprofileBirthdayWidgetMode.PROFILE) {
      const lang = locale.split('_')[0]
      this._translateService.setFallbackLang(lang)
      this._translateService.setTranslation(lang, translations, true)
    }
  }

  private _getTranslations(country: string, locale: string): Observable<any> {
    return this._localisationService.getBirthdayWidgetConfiguration(country, locale).pipe(map((response) => response.translations))
  }
}
